export default __webpack_public_path__ + "static/media/servicelive.cca578c4.png";